import Cookie from 'utils/cookies';
import { getQueryParams } from 'utils/common';

function isDev() {
  return window.location.href.indexOf('test') !== -1;
}

function shouldAppendIOSParam() {
  const iosVer = Cookie.get('iosappipver');
  let isNewIOSVer = false;
  // eslint-disable-next-line no-restricted-globals
  if (typeof iosVer === 'string' && iosVer.length > 0 && !isNaN(iosVer)) {
    const intIOSVer = parseInt(iosVer, 10);
    if (intIOSVer && intIOSVer >= 611) {
      isNewIOSVer = true;
    }
  }

  return isNewIOSVer;
}

function shouldAppendPCParameter(newUrl) {
  let addPrimeUserParameter = false;
  try {
    const domainVisited = Cookie.get('pcdomainvisit');
    const clientState =
      typeof window === 'object' && window.App && window.App.state
        ? window.App.state
        : {};
    if (
      clientState &&
      clientState.isPrime &&
      clientState.isFrmapp &&
      !clientState.isChromeTab &&
      clientState.isMobile &&
      domainVisited !== '1' &&
      newUrl &&
      newUrl.indexOf('.gadgetsnow.com') === -1 &&
      newUrl.split('/')[2] !== window.location.hostname
    ) {
      addPrimeUserParameter = true;
    }
  } catch (e) {
    // console.log(e);
  }

  return addPrimeUserParameter;
}

export function shouldAppendFrmApp() {
  let shouldAppendFrmAppToUrl;
  const queryParams = window.location.href.split('?')[1] || '';
  if (
    queryParams.indexOf('frmapp=yes') > -1 &&
    (window.location.href.indexOf('.indiatimes.com') > -1 ||
      window.location.href.indexOf('.timesofindia.com') > -1 ||
      window.location.href.indexOf('.gadgetsnow.com') > -1)
  ) {
    shouldAppendFrmAppToUrl = true;
  }
  return shouldAppendFrmAppToUrl;
}

export function appendFrmAppToUrl(urlToAppend) {
  let newUrl = urlToAppend || '';
  const url = urlToAppend || '';
  if (url.indexOf('#') > -1 && url.split('#').length > 1) {
    newUrl = url.split('#')[0];
  }
  if (url.indexOf('?') > -1) {
    newUrl += '&frmapp=yes';
  } else {
    newUrl += '?frmapp=yes';
  }

  if (shouldAppendPCParameter(newUrl)) {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (!isIOS) {
      newUrl += '&pc=yes';
    } else if (isIOS && shouldAppendIOSParam()) {
      newUrl += '&pc=yes&newver=1';
    }
  }

  if (url.indexOf('#') > -1 && url.split('#').length > 1) {
    newUrl += `#${url.split('#')[1]}`;
  }

  if (isDev()) {
    console.log('*** appendFrmAppToUrl', newUrl);
  }
  return newUrl;
}

export function handleLinksForFrmapp() {
  document.addEventListener('click', e => {
    if (!shouldAppendFrmApp()) {
      return;
    }

    const anchor = e.target.closest('a');
    if (!anchor || (anchor && anchor.getAttribute('frmappuse') === '1')) {
      return;
    }
    if (isDev()) {
      console.log('***', e, e.target, e.defaultPrevented);
    }
    if (
      !e.defaultPrevented &&
      (!!anchor.getAttribute('href') || !!anchor.href)
    ) {
      e.preventDefault();
      window.location.href = appendFrmAppToUrl(anchor.getAttribute('href'));
    }
  });
}

// eslint-disable-next-line consistent-return
export function setupWebViewJavascriptBridge(callback) {
  if (window.tilAppWebBridge) {
    return callback(window.tilAppWebBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  const WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}
export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export function printSubsDeeplink(bridge) {
  if (typeof bridge !== 'undefined') {
    bridge.callHandler(
      'invokeNativeDeeplink',
      {
        printSubsDLink:
          'toiapp://open-$|$-id=1-$|$-type=planPage-$|$-source=listing-$|$-openPaymentSameAsStory=1',
        returnUrl: window.location.href,
      },
      response => {
        console.log(
          'bridge created and invokeNativeDeeplink called: ',
          JSON.parse(response),
        );
      },
    );
  } else if (typeof window.javascript_obj !== 'undefined') {
    window.javascript_obj.invokeNativeDeeplink(
      JSON.stringify({
        printSubsDLink:
          'toiapp://open-$|$-id=1-$|$-type=planPage-$|$-source=listing-$|$-openPaymentSameAsStory=1',
        returnUrl: window.location.href,
      }),
    );
  }
}

export function printSignInDeeplink(bridge) {
  if (typeof bridge !== 'undefined') {
    bridge.callHandler('requestLogin', {});
  } else if (typeof window.javascript_obj !== 'undefined') {
    window.javascript_obj.forceLogOutAndLogin('IsLogin', window.location.href);
  }
}

export function initialiseUnifiedAppLoginHandlers(_this, callback) {
  const invokeAfterIsAppReadySuccess = () => {
    try {
      if (
        navigator.userAgent.includes('iPhone') ||
        navigator.userAgent.includes('iPad')
      ) {
        if (
          typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined'
        ) {
          const loginCommand = `checkLoggedInUser('unifiedLoginCheck', 'unifiedLoginCheck')`;
          window.webkit.messageHandlers.tilAppWebBridge.postMessage(
            loginCommand,
          );
        }
      } else if (typeof window.tilAppWebBridge !== 'undefined') {
        window.tilAppWebBridge.checkLoggedInUser(
          'unifiedLoginCheck',
          'unifiedLoginCheck',
        );
      }
    } catch (error) {
      console.error(
        `=== initialiseUnifiedAppLoginHandlers failed === ${error}`,
      );
    }
  };
  window.initiateAppToWebConnection = response => {
    console.log(response);
    invokeAfterIsAppReadySuccess();
  };
  window.isAppReady = () => {
    invokeAfterIsAppReadySuccess();
  };

  window.onLoginSuccess = (reqId, userInfo) => {
    try {
      userInfo = JSON.parse(userInfo);
      console.log('userInfo', userInfo);
      window.userInfoForApp = userInfo;
      if (userInfo.ssoid && userInfo.ticketid) {
        callback.call(_this, () => {}, userInfo);
      }
    } catch (err) {
      console.error(err);
    }
  };
  window.onLoginFailed = (reqId, userInfo, extraInfo) => {
    if (extraInfo === 'unifiedLoginCheck') {
      // eslint-disable-next-line no-empty
    } else if (extraInfo === 'unifiedLoginRequest') {
    }
    userInfo = JSON.parse(userInfo);
    console.log('userInfo', userInfo);
    callback.call(_this, () => {}, userInfo);
  };

  window.messageFromApp = () => {
    window.location.reload();
  };
}

export function requestUnifiedAppLogin() {
  if (
    navigator.userAgent.includes('iPhone') ||
    navigator.userAgent.includes('iPad')
  ) {
    if (typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined') {
      const loginCommand = `requestLogin('unifiedLoginRequest', 'unifiedLoginRequest')`;
      window.webkit.messageHandlers.tilAppWebBridge.postMessage(loginCommand);
    }
  } else if (typeof window.tilAppWebBridge !== 'undefined') {
    window.tilAppWebBridge.requestLogin(
      'unifiedLoginRequest',
      'unifiedLoginRequest',
    );
  }
}
export function unifiedOpenDeepLinkUrl(urlObj) {
  const deep_link_url_obj = JSON.stringify(urlObj);
  if (
    navigator.userAgent.includes('iPhone') ||
    navigator.userAgent.includes('iPad')
  ) {
    if (typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined') {
      window.webkit.messageHandlers.tilAppWebBridge.postMessage(
        `${deep_link_url_obj}`,
      );
    }
  } else if (typeof window.tilAppWebBridge !== 'undefined') {
    window.tilAppWebBridge.postMessage(`${deep_link_url_obj}`);
  }
}

export const hasNewTilBridge = () => {
  const byPassBrige =
    typeof window !== 'undefined' &&
    getQueryParams('testAppUser') === 'true' &&
    !!(sessionStorage && sessionStorage.getItem('mockUserData'));
  if (
    typeof window !== 'undefined' &&
    typeof window.webkit !== 'undefined' &&
    typeof window.webkit.messageHandlers !== 'undefined' &&
    typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined'
  ) {
    return true;
  } else if (
    typeof window !== 'undefined' &&
    typeof window.tilAppWebBridge !== 'undefined'
  ) {
    return true;
  } else if (byPassBrige) {
    return true;
  }

  return false;
};

export const allowedAppVersion = () => {
  if (typeof window !== 'undefined') {
    if (
      getQueryParams('frmapp') === 'yes' &&
      (getQueryParams('iosver') <= '12.4.20' ||
        getQueryParams('andver') < '8424')
    ) {
      return true;
    }
  }
  return true;
};
